import { render, staticRenderFns } from "./ProfileFootbar.vue?vue&type=template&id=00bb1c86"
import script from "./ProfileFootbar.vue?vue&type=script&lang=js"
export * from "./ProfileFootbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports